import { useMemo } from 'react'
import type { DisplayTeam } from '@mission.io/mission-toolkit'
import { useCanvasStudentInfo } from '../../../../store/selectors/jrPlusState/canvas'

/**
 * A hook that determines if any students on a team are locked
 * @param {?DisplayTeam} team The team to check for locked students
 * @returns {boolean} Whether any students on the team are locked
 */
export function useHasLockedStudents(team: ?DisplayTeam): boolean {
	const canvasStudentInfo = useCanvasStudentInfo()

	return useMemo(() => {
		if (!team) return false
		return [team.lead, ...team.students]
			.filter(Boolean)
			.some(student => canvasStudentInfo[student.id]?.isBlocked)
	}, [team, canvasStudentInfo])
}
